<div class="detail" [class.visible]="view">
  <header>
    <div *ngIf="view" class="settings-icon" (click)="toggleFieldEditor()"></div>
    <div class="close" (click)="close()"></div>
    <h2 *ngIf="!view">Detail</h2>
    <h2 *ngIf="view">{{view.name}}</h2>
  </header>
  <div class="detail-body">
    <section>
      <div *ngIf="!view && errors.length === 0" class="loading">Loading . . .</div>

      <div *ngIf="view" class="view-fields">
        <div *ngIf="!targetManageable && !isSelfDocument" class="manage-notice">
          You can view this user but not manage them: their user group is outside the groups you may manage.
        </div>
        <app-correction-list *ngIf="correctionBanner"
                             [correctionFor]="correctionBanner.correctionFor"
                             [corrections]="[]"
                             [type]="document?.type"
                             [divisor]="correctionBanner.divisor"
                             (open)="navigateToRecord($event)"></app-correction-list>
        <ng-container *ngFor="let field of activeFields">
          <div class="field" *ngIf="isFieldVisible(field)">
            <label *ngIf="!isNavField(field)">
              <span *ngIf="field.locationSpecific && activeLocation?._id">{{activeLocation.name}} </span>{{field.name}}<span *ngIf="field.required && isFieldEditable(field)" class="required">*</span>
              <button *ngIf="isFieldEditable(field) && hasRemoteLookup(field)" type="button" class="remote-lookup-btn"
                [class.loading]="remoteLookupLoading[field.path]" [disabled]="remoteLookupLoading[field.path]"
                title="Look up from remote source" (click)="performRemoteLookup(field)">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 12a9 9 0 1 1-2.64-6.36M21 3v4h-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </label>

            <div *ngIf="field.locationSpecific && (!activeLocation || !activeLocation._id)" class="value location-hint">
              Select a location to edit this field.
            </div>

            <!-- Array fields -->
            <ng-container *ngIf="isArrayField(field)">

              <!-- Array string editable with suggestions -->
              <ng-container *ngIf="isFieldEditable(field) && field.type === 'string' && field.suggestValues">
                <div class="chips" [class.sortable]="field.sortable" cdkDropList
                     [cdkDropListDisabled]="!field.sortable" (cdkDropListDropped)="dropArrayValue($event, field)">
                  <div class="chip" *ngFor="let val of editValues[field.path]; let i = index"
                       cdkDrag [cdkDragDisabled]="!field.sortable">
                    {{val}}<div class="chip-remove" (click)="removeArrayValue(field, i)"></div>
                  </div>
                  <div class="chip ghost" *ngIf="(arrayInputValues[field.path] || '').trim()">{{arrayInputValues[field.path]}}</div>
                </div>
                <div class="array-input-wrap" [class.pending]="(arrayInputValues[field.path] || '').trim()"
                     *ngIf="editValues[field.path]?.length < field.limit">
                <app-text-suggest
                  [module]="'view'"
                  [path]="field.path"
                  [params]="{ viewKey: viewKey, locationId: activeLocation?._id, documentId: documentId, documentValues: editValues }"
                  [value]="arrayInputValues[field.path] || ''"
                  [excludeValues]="editValues[field.path] || []"
                  (valueChange)="arrayInputValues[field.path] = $event"
                  (suggestionSelected)="onArraySuggestionSelected(field, $event)"
                  (keydown)="onArrayStringKeydown($event, field)">
                </app-text-suggest>
                <span class="enter-hint" *ngIf="(arrayInputValues[field.path] || '').trim()">&#9166;</span>
                </div>
                <div class="limit-count">{{editValues[field.path]?.length || 0}} / {{field.limit}}</div>
              </ng-container>

              <!-- Array string editable without suggestions -->
              <ng-container *ngIf="isFieldEditable(field) && field.type === 'string' && !field.suggestValues">
                <div class="chips" [class.sortable]="field.sortable" cdkDropList
                     [cdkDropListDisabled]="!field.sortable" (cdkDropListDropped)="dropArrayValue($event, field)">
                  <div class="chip" *ngFor="let val of editValues[field.path]; let i = index"
                       cdkDrag [cdkDragDisabled]="!field.sortable">
                    {{val}}<div class="chip-remove" (click)="removeArrayValue(field, i)"></div>
                  </div>
                  <div class="chip ghost" *ngIf="(arrayInputValues[field.path] || '').trim()">{{arrayInputValues[field.path]}}</div>
                </div>
                <div class="array-input-wrap" [class.pending]="(arrayInputValues[field.path] || '').trim()"
                     *ngIf="editValues[field.path]?.length < field.limit">
                <input type="text"
                       [(ngModel)]="arrayInputValues[field.path]"
                       (keydown)="onArrayStringKeydown($event, field)" />
                <span class="enter-hint" *ngIf="(arrayInputValues[field.path] || '').trim()">&#9166;</span>
                </div>
                <div class="limit-count">{{editValues[field.path]?.length || 0}} / {{field.limit}}</div>
              </ng-container>

              <!-- Array sourceCollection editable -->
              <ng-container *ngIf="isFieldEditable(field) && field.type === 'sourceCollection'">
                <div class="chips" [class.sortable]="field.sortable" cdkDropList
                     [cdkDropListDisabled]="!field.sortable" (cdkDropListDropped)="dropArrayValue($event, field)">
                  <div class="chip" *ngFor="let item of displayValues[field.path]; let i = index"
                       cdkDrag [cdkDragDisabled]="!field.sortable"
                       [class.locked]="!canRemoveSourceValue(field, i)"
                       [title]="canRemoveSourceValue(field, i) ? '' : 'You are not authorized to change this assignment'">
                    {{item.display}}<div *ngIf="canRemoveSourceValue(field, i)" class="chip-remove" (click)="removeSourceValue(field, i)"></div>
                  </div>
                </div>
                <app-source-select
                  *ngIf="editValues[field.path]?.length < field.limit"
                  [viewKey]="viewKey"
                  [path]="field.path"
                  [locationId]="activeLocation?._id || ''"
                  [documentId]="documentId"
                  [documentValues]="editValues"
                  [displayValue]="''"
                  [excludeValues]="editValues[field.path] || []"
                  (selectionChange)="addSourceValue(field, $event)">
                </app-source-select>
                <div class="empty-hint" *ngIf="field.emptyHint && !(editValues[field.path]?.length)">{{field.emptyHint}}</div>
                <div class="limit-count">{{editValues[field.path]?.length || 0}} / {{field.limit}}</div>
              </ng-container>

              <!-- Array string read-only -->
              <div *ngIf="!isFieldEditable(field) && field.type === 'string'" class="chips">
                <div class="chip" *ngFor="let val of editValues[field.path]">{{val}}</div>
              </div>

              <!-- Array telephone editable -->
              <ng-container *ngIf="isFieldEditable(field) && field.type === 'telephone'">
                <div class="chips" [class.sortable]="field.sortable" cdkDropList
                     [cdkDropListDisabled]="!field.sortable" (cdkDropListDropped)="dropArrayValue($event, field)">
                  <div class="chip" *ngFor="let val of editValues[field.path]; let i = index"
                       cdkDrag [cdkDragDisabled]="!field.sortable">
                    {{val | rf:'phone'}}<div class="chip-remove" (click)="removeArrayValue(field, i)"></div>
                  </div>
                  <div class="chip ghost" *ngIf="(arrayInputValues[field.path] || '').trim()">{{arrayInputValues[field.path]}}</div>
                </div>
                <div class="array-input-wrap" [class.pending]="(arrayInputValues[field.path] || '').trim()"
                     *ngIf="editValues[field.path]?.length < field.limit">
                <input type="tel"
                       mask="0 (000) 000-0000"
                       [(ngModel)]="arrayInputValues[field.path]"
                       (keydown)="onArrayTelephoneKeydown($event, field)" />
                <span class="enter-hint" *ngIf="(arrayInputValues[field.path] || '').trim()">&#9166;</span>
                </div>
                <div class="limit-count">{{editValues[field.path]?.length || 0}} / {{field.limit}}</div>
              </ng-container>

              <!-- Array telephone read-only -->
              <div *ngIf="!isFieldEditable(field) && field.type === 'telephone'" class="chips">
                <div class="chip" *ngFor="let val of editValues[field.path]">{{val | rf:'phone'}}</div>
              </div>

              <!-- Array sourceCollection read-only -->
              <div *ngIf="!isFieldEditable(field) && field.type === 'sourceCollection'" class="chips">
                <div class="chip" *ngFor="let item of displayValues[field.path]">{{item.display}}</div>
                <div class="empty-hint" *ngIf="field.emptyHint && !(displayValues[field.path]?.length)">{{field.emptyHint}}</div>
              </div>

              <!-- Array image editable -->
              <ng-container *ngIf="isFieldEditable(field) && field.type === 'image'">
                <div class="image-drop-zone"
                     [class.drag-over]="dragOverField === field"
                     (dragover)="onImageDragOver($event, field)"
                     (dragleave)="onImageDragLeave($event)"
                     (drop)="onImageDrop($event, field)">
                  <div class="image-thumbnails">
                    <div class="image-thumbnail" *ngFor="let url of editValues[field.path]; let i = index">
                      <img [src]="getImageThumbnailUrl(url)" [alt]="field.name" />
                      <div class="image-remove" (click)="removeArrayValue(field, i)"></div>
                    </div>
                  </div>
                  <div *ngIf="editValues[field.path]?.length < field.limit && canUploadImages && !uploading"
                       class="image-upload-area">
                    <div *ngIf="activeImageField !== field" class="image-upload-button"
                         (click)="setActiveImageField(field)">+ Add Image</div>
                    <div *ngIf="activeImageField === field && uploaderUrl" class="image-uploader">
                      <iframe title="Upload Image" [src]="uploaderUrl" frameborder="0" height="80px"
                              width="100%"></iframe>
                      <div class="image-upload-cancel" (click)="setActiveImageField(field)">Cancel</div>
                    </div>
                  </div>
                  <div *ngIf="uploading" class="image-uploading">Uploading...</div>
                </div>
                <div class="limit-count">{{editValues[field.path]?.length || 0}} / {{field.limit}}</div>
              </ng-container>

              <!-- Array image read-only -->
              <div *ngIf="!isFieldEditable(field) && field.type === 'image'" class="image-thumbnails">
                <div class="image-thumbnail" *ngFor="let url of editValues[field.path]">
                  <img [src]="getImageThumbnailUrl(url)" [alt]="field.name" />
                </div>
              </div>

              <!-- Array address editable -->
              <ng-container *ngIf="isFieldEditable(field) && field.type === 'address'">
                <div class="address-list">
                  <div class="address-card" *ngFor="let addr of editValues[field.path]; let i = index">
                    <div class="address-card-header">
                      <span>Address {{i + 1}}</span>
                      <div class="chip-remove" (click)="removeAddress(field, i)"></div>
                    </div>
                    <input type="text" placeholder="Street Address" [(ngModel)]="addr.streetAddress" />
                    <input type="text" placeholder="Address Ext." [(ngModel)]="addr.streetAddressExt" />
                    <input type="text" placeholder="City" [(ngModel)]="addr.addressLocality" />
                    <div class="address-row">
                      <select [(ngModel)]="addr.addressRegion">
                        <option value="" disabled selected>State</option>
                        <option *ngFor="let state of states" [value]="state.key">{{state.name}}</option>
                      </select>
                      <input type="text" placeholder="Zip" [(ngModel)]="addr.postalCode" />
                    </div>
                  </div>
                </div>
                <div *ngIf="editValues[field.path]?.length < field.limit" class="address-add" (click)="addAddress(field)">+ Add Address</div>
                <div class="limit-count">{{editValues[field.path]?.length || 0}} / {{field.limit}}</div>
              </ng-container>

              <!-- Array address read-only -->
              <ng-container *ngIf="!isFieldEditable(field) && field.type === 'address'">
                <div class="address-list">
                  <div class="address-card read-only" *ngFor="let addr of editValues[field.path]">
                    <div class="value">{{formatAddress(addr)}}</div>
                  </div>
                </div>
              </ng-container>

            </ng-container>

            <!-- Single-value fields (unchanged) -->
            <ng-container *ngIf="!isArrayField(field)">

            <select *ngIf="isFieldEditable(field) && field.type === 'string' && hasOptions(field)"
                    [(ngModel)]="editValues[field.path]">
              <option value="" disabled *ngIf="!editValues[field.path]">Select . . .</option>
              <option *ngIf="editValues[field.path] && field.options.indexOf(editValues[field.path]) === -1"
                      [value]="editValues[field.path]">{{editValues[field.path]}}</option>
              <option *ngFor="let opt of field.options" [value]="opt">{{opt}}</option>
            </select>

            <app-text-suggest
              *ngIf="isFieldEditable(field) && field.type === 'string' && field.suggestValues && !hasOptions(field)"
              [module]="'view'"
              [path]="field.path"
              [params]="{ viewKey: viewKey, locationId: activeLocation?._id, documentId: documentId, documentValues: editValues }"
              [value]="editValues[field.path]"
              (valueChange)="editValues[field.path] = $event">
            </app-text-suggest>

            <input *ngIf="isFieldEditable(field) && field.type === 'string' && !field.suggestValues && !hasOptions(field) && field.format !== 'multiline'"
                   type="text"
                   [(ngModel)]="editValues[field.path]" />

            <textarea *ngIf="isFieldEditable(field) && field.type === 'string' && !field.suggestValues && !hasOptions(field) && field.format === 'multiline'"
                      [(ngModel)]="editValues[field.path]"></textarea>

            <input *ngIf="isFieldEditable(field) && field.type === 'currency'"
                   type="text"
                   inputmode="decimal"
                   mask="comma_separator.2"
                   prefix="$ "
                   [(ngModel)]="editValues[field.path]" />

            <!-- Advanced price: the input edits the standard price; alternate
                 per-location prices are managed in the Advanced Pricing dialog. -->
            <ng-container *ngIf="field.type === 'advancedPrice'">
              <input *ngIf="isFieldEditable(field)"
                     type="text"
                     inputmode="decimal"
                     mask="comma_separator.2"
                     prefix="$ "
                     [(ngModel)]="editValues[field.path]" />
              <div *ngIf="!isFieldEditable(field)" class="value">
                {{editValues[field.path] == null ? '—' : ((editValues[field.path] * 100) | rf:'currency')}}
              </div>
              <div *ngIf="document && document[field.path + 'LocationCount'] > 0" class="price-varies">
                Price differs at {{document[field.path + 'LocationCount']}}
                {{document[field.path + 'LocationCount'] === 1 ? 'location' : 'locations'}}.
              </div>
              <button *ngIf="canAdvancedPricing" type="button" class="advanced-pricing-btn"
                      (click)="openAdvancedPricing()">
                Advanced Pricing
              </button>
            </ng-container>

            <input *ngIf="isFieldEditable(field) && field.type === 'number'"
                   type="number"
                   step="any"
                   [(ngModel)]="editValues[field.path]" />

            <input *ngIf="isFieldEditable(field) && field.type === 'telephone'"
                   type="tel"
                   mask="0 (000) 000-0000"
                   [(ngModel)]="editValues[field.path]" />

            <app-toggle
              *ngIf="isFieldEditable(field) && field.type === 'boolean'"
              [checked]="editValues[field.path]"
              (valueChanged)="toggleBoolean(field.path)">
            </app-toggle>

            <div *ngIf="isFieldEditable(field) && field.type === 'colorPicker'"
                 class="color-block"
                 [cpOutputFormat]="'rgba'"
                 [(colorPicker)]="colorDisplay[field.path]"
                 [style.background]="colorDisplay[field.path]"
                 (colorPickerChange)="onColorChange(field, $event)"></div>

            <div *ngIf="!isFieldEditable(field) && field.type === 'colorPicker'"
                 class="color-block"
                 [style.background]="colorDisplay[field.path]"></div>

            <app-filter-date-range
              *ngIf="isFieldEditable(field) && field.type === 'dateTime' && dateTimeSettings[field.path]"
              [rangeConfig]="dateTimeSettings[field.path]">
            </app-filter-date-range>

            <app-source-select
              *ngIf="isFieldEditable(field) && field.type === 'sourceCollection'"
              [viewKey]="viewKey"
              [path]="field.path"
              [locationId]="activeLocation?._id || ''"
              [documentId]="documentId"
              [documentValues]="editValues"
              [displayValue]="displayValues[field.path]"
              (selectionChange)="onSourceSelectionChange(field, $event)">
            </app-source-select>

            <!-- sourceCollection fields with linkViewKey open the referenced
                 record in that view (e.g. Replenishes → retail-product) -->
            <div *ngIf="field.type === 'sourceCollection' && field.linkViewKey && editValues[field.path]"
                 class="source-link"
                 (click)="openLinkedRecord(field)">Open {{field.name}} ›</div>

            <!-- Single image editable -->
            <ng-container *ngIf="isFieldEditable(field) && field.type === 'image'">
              <div class="image-drop-zone"
                   [class.drag-over]="dragOverField === field"
                   (dragover)="onImageDragOver($event, field)"
                   (dragleave)="onImageDragLeave($event)"
                   (drop)="onImageDrop($event, field)">
                <div *ngIf="editValues[field.path]" class="image-thumbnails">
                  <div class="image-thumbnail">
                    <img [src]="getImageThumbnailUrl(editValues[field.path])" [alt]="field.name" />
                    <div class="image-remove" (click)="clearImageValue(field)"></div>
                  </div>
                </div>
                <div *ngIf="canUploadImages && !uploading" class="image-upload-area">
                  <div *ngIf="activeImageField !== field" class="image-upload-button"
                       (click)="setActiveImageField(field)">
                    <span *ngIf="!editValues[field.path]">+ Add Image</span>
                    <span *ngIf="editValues[field.path]">Replace Image</span>
                  </div>
                  <div *ngIf="activeImageField === field && uploaderUrl" class="image-uploader">
                    <iframe title="Upload Image" [src]="uploaderUrl" frameborder="0" height="80px"
                            width="100%"></iframe>
                    <div class="image-upload-cancel" (click)="setActiveImageField(field)">Cancel</div>
                  </div>
                </div>
                <div *ngIf="uploading" class="image-uploading">Uploading...</div>
              </div>
            </ng-container>

            <!-- Single image read-only -->
            <ng-container *ngIf="!isFieldEditable(field) && field.type === 'image'">
              <div *ngIf="editValues[field.path]" class="image-thumbnails">
                <div class="image-thumbnail">
                  <img [src]="getImageThumbnailUrl(editValues[field.path])" [alt]="field.name" />
                </div>
              </div>
              <div *ngIf="!editValues[field.path]" class="value">No image</div>
            </ng-container>

            <!-- Single address editable -->
            <ng-container *ngIf="isFieldEditable(field) && field.type === 'address'">
              <div class="address-card">
                <input type="text" placeholder="Street Address" [(ngModel)]="editValues[field.path].streetAddress" />
                <input type="text" placeholder="Address Ext." [(ngModel)]="editValues[field.path].streetAddressExt" />
                <input type="text" placeholder="City" [(ngModel)]="editValues[field.path].addressLocality" />
                <div class="address-row">
                  <select [(ngModel)]="editValues[field.path].addressRegion">
                    <option value="" disabled selected>State</option>
                    <option *ngFor="let state of states" [value]="state.key">{{state.name}}</option>
                  </select>
                  <input type="text" placeholder="Zip" [(ngModel)]="editValues[field.path].postalCode" />
                </div>
              </div>
            </ng-container>

            <!-- Single address read-only -->
            <div *ngIf="!isFieldEditable(field) && field.type === 'address'" class="value">
              {{formatAddress(editValues[field.path])}}
            </div>

            <div *ngIf="!isFieldEditable(field) && field.type === 'string'" class="value">
              {{editValues[field.path]}}
            </div>

            <div *ngIf="!isFieldEditable(field) && field.type === 'currency'" class="value">
              {{editValues[field.path] == null ? '—' : ((editValues[field.path] * 100) | rf:'currency')}}
            </div>

            <div *ngIf="!isFieldEditable(field) && field.type === 'number'" class="value">
              {{editValues[field.path] == null ? '—' : (field.format === 'currency' ? formatCalculatedValue(+editValues[field.path], 'currency') : editValues[field.path])}}
            </div>

            <div *ngIf="!isFieldEditable(field) && field.type === 'telephone'" class="value">
              {{editValues[field.path] | rf:'phone'}}
            </div>

            <div *ngIf="!isFieldEditable(field) && field.type === 'dateTime'" class="value">
              {{document[field.path] | rf:'dateTime'}}
            </div>

            <div *ngIf="!isFieldEditable(field) && field.type === 'boolean'" class="value">
              {{editValues[field.path] | rf:'boolean'}}
            </div>

            <div *ngIf="!isFieldEditable(field) && field.type === 'sourceCollection'" class="value">
              {{displayValues[field.path]}}
            </div>

            <!-- Rich text editable -->
            <ng-container *ngIf="isFieldEditable(field) && field.type === 'richText'">
              <div class="rt-toolbar" (mousedown)="$event.preventDefault()">
                <div class="rt-btn" [class.active]="rtState[field.path]?.bold"
                     (mousedown)="rtExec($event, field, 'bold')"><b>B</b></div>
                <div class="rt-btn" [class.active]="rtState[field.path]?.italic"
                     (mousedown)="rtExec($event, field, 'italic')"><i>I</i></div>
                <div class="rt-btn" [class.active]="rtState[field.path]?.underline"
                     (mousedown)="rtExec($event, field, 'underline')"><u>U</u></div>
                <div class="rt-sep"></div>
                <div class="rt-btn" [class.active]="rtState[field.path]?.justifyLeft"
                     (mousedown)="rtExec($event, field, 'justifyLeft')" title="Align Left">
                  <svg width="14" height="12" viewBox="0 0 14 12"><rect x="0" y="0" width="14" height="2" fill="currentColor"/><rect x="0" y="5" width="9" height="2" fill="currentColor"/><rect x="0" y="10" width="14" height="2" fill="currentColor"/></svg>
                </div>
                <div class="rt-btn" [class.active]="rtState[field.path]?.justifyCenter"
                     (mousedown)="rtExec($event, field, 'justifyCenter')" title="Align Center">
                  <svg width="14" height="12" viewBox="0 0 14 12"><rect x="0" y="0" width="14" height="2" fill="currentColor"/><rect x="2.5" y="5" width="9" height="2" fill="currentColor"/><rect x="0" y="10" width="14" height="2" fill="currentColor"/></svg>
                </div>
                <div class="rt-btn" [class.active]="rtState[field.path]?.justifyRight"
                     (mousedown)="rtExec($event, field, 'justifyRight')" title="Align Right">
                  <svg width="14" height="12" viewBox="0 0 14 12"><rect x="0" y="0" width="14" height="2" fill="currentColor"/><rect x="5" y="5" width="9" height="2" fill="currentColor"/><rect x="0" y="10" width="14" height="2" fill="currentColor"/></svg>
                </div>
                <div class="rt-sep"></div>
                <div class="rt-btn-dropdown">
                  <div class="rt-btn" (mousedown)="toggleRtDropdown($event, field, 'fontSize')" title="Font Size">
                    <span class="rt-size-lg">A</span><span class="rt-size-sm">A</span>
                  </div>
                  <div *ngIf="rtDropdown[field.path] === 'fontSize'" class="rt-dropdown">
                    <div *ngFor="let size of rtFontSizes" class="rt-dropdown-item"
                         (mousedown)="rtSetFontSize($event, field, size.value)">{{size.label}}</div>
                  </div>
                </div>
                <div class="rt-btn-dropdown">
                  <div class="rt-btn" (mousedown)="toggleRtDropdown($event, field, 'fontColor')" title="Font Color">
                    <span class="rt-color-icon">A</span>
                  </div>
                  <div *ngIf="rtDropdown[field.path] === 'fontColor'" class="rt-dropdown rt-color-grid">
                    <div *ngFor="let color of rtColors" class="rt-color-swatch"
                         [style.background-color]="color"
                         (mousedown)="rtSetColor($event, field, color)"></div>
                  </div>
                </div>
                <div class="rt-sep"></div>
                <div class="rt-btn" (mousedown)="rtStartLink($event, field)" title="Link">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg>
                </div>
                <div class="rt-btn" (mousedown)="rtClearFormat($event, field)" title="Clear Formatting">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7V4h16v3"/><path d="M5 20h6"/><path d="M13 4l-5 16"/><path d="M15 15l5 5"/><path d="M20 15l-5 5"/></svg>
                </div>
                <div class="rt-btn" (mousedown)="rtClearValue($event, field)" title="Clear">
                  <svg width="14" height="14" viewBox="0 0 14 14"><path d="M3 4h8l-.7 8.2a1 1 0 01-1 .8H4.7a1 1 0 01-1-.8L3 4z" stroke="currentColor" stroke-width="1.3" fill="none" stroke-linejoin="round"/><path d="M1.5 4h11M5.5 4V2.5a1 1 0 011-1h1a1 1 0 011 1V4" stroke="currentColor" stroke-width="1.3" fill="none" stroke-linecap="round"/></svg>
                </div>
              </div>
              <div *ngIf="rtLinkInput[field.path]?.active" class="rt-link-bar">
                <input type="text" placeholder="https://" [(ngModel)]="rtLinkInput[field.path].url"
                       (keydown.enter)="rtApplyLink(field)" />
                <div class="rt-link-apply" (click)="rtApplyLink(field)">Apply</div>
                <div class="rt-link-cancel" (click)="rtCancelLink(field)">Cancel</div>
              </div>
              <div class="rt-editor" contenteditable="true"
                   [attr.data-path]="field.path"
                   (input)="onRtInput($event, field)"
                   (paste)="onRtPaste($event, field)"
                   (mouseup)="updateRtState(field)"
                   (keyup)="updateRtState(field)">
              </div>
            </ng-container>

            <!-- Rich text read-only -->
            <div *ngIf="!isFieldEditable(field) && field.type === 'richText'" class="value rt-readonly"
                 [innerHTML]="getSafeHtml(editValues[field.path])"></div>

            <!-- Calculated field -->
            <div *ngIf="field.type === 'calculated'" class="value calculated">
              {{formatCalculatedValue(getCalculatedValue(field), field.format)}}
            </div>

            <!-- Parent link: clickable navigation to the parent record -->
            <ng-container *ngIf="field.type === 'parentLink' && context[field.path]">
              <label class="nav-header">{{field.name}}</label>
              <div class="related-record" (click)="navigateToRecord(context[field.path]._id, field.viewKey)">
                {{context[field.path].display}}
              </div>
            </ng-container>

            <!-- Child list: clickable children + optional add button -->
            <ng-container *ngIf="field.type === 'childList'">
              <label class="nav-header" *ngIf="context[field.path]?.length">{{field.name}}</label>
              <div class="related-record" *ngFor="let child of context[field.path]"
                   (click)="navigateToRecord(child._id, field.viewKey)">
                {{child.display}}
              </div>
              <div *ngIf="field.addRoute && canUpdate && canAddChild(field)" class="button yellow add-child"
                   (click)="addChild(field)">{{field.addLabel || 'Add'}}</div>
            </ng-container>

            <!-- Move items: pick a target record and move members into it -->
            <ng-container *ngIf="field.type === 'moveItems' && context[field.path]?.length && canUpdate">
              <label class="nav-header">{{field.name}}</label>
              <div class="move-description" *ngIf="field.description">{{field.description}} {{document.name}} to</div>
              <select [(ngModel)]="moveTargets[field.path]">
                <option [ngValue]="''" disabled>(Choose)</option>
                <option *ngFor="let opt of context[field.path]" [ngValue]="opt._id">{{opt.display}}</option>
              </select>
              <div class="move-actions">
                <button class="button yellow" [disabled]="!moveTargets[field.path] || movingItems"
                        (click)="doMoveItems(field)">{{field.actionLabel || 'Move'}}</button>
              </div>
            </ng-container>

            <!-- Detail link: read-only cached value that opens a legacy detail
                 route (customer/purchase/...) or a routeOverrides target -->
            <ng-container *ngIf="field.type === 'detailLink'">
              <label class="nav-header">{{field.name}}</label>
              <div *ngIf="detailLinkId(field)" class="related-record" (click)="openDetailLink(field)">
                {{document[field.path]}}
              </div>
              <div *ngIf="!detailLinkId(field)" class="value">{{document[field.path]}}</div>
            </ng-container>

            <!-- Corrections: trail applied to this transaction + backlink, from getView context -->
            <app-correction-list *ngIf="field.type === 'corrections' && context[field.path]"
                                 [corrections]="context[field.path].corrections"
                                 [correctionFor]="null"
                                 [type]="document?.type"
                                 [divisor]="context[field.path].divisor"
                                 (open)="navigateToRecord($event)"></app-correction-list>

            <!-- Notes: typed note thread, preloaded by getView (no extra round-trip) -->
            <app-note *ngIf="field.type === 'notes' && field.noteType"
                      [type]="field.noteType"
                      [entity]="document"
                      [preloadedNotes]="context[field.path]"></app-note>

            </ng-container>
          </div>
        </ng-container>

        <div *ngIf="canUpdate || permittedActions.length || permittedActionsAboveSave.length" class="buttons">
          <div *ngFor="let action of permittedActionsAboveSave"
               class="button" [ngClass]="action.class || ''"
               (click)="executeAction(action)">{{action.name}}<span *ngIf="actionCounts[action.key] != null"> ({{actionCounts[action.key]}})</span></div>
          <div *ngIf="canUpdate" class="button green" (click)="save()">Save</div>
          <div *ngFor="let action of permittedActions"
               class="button" [ngClass]="action.class || ''"
               (click)="executeAction(action)">{{action.name}}<span *ngIf="actionCounts[action.key] != null"> ({{actionCounts[action.key]}})</span></div>
          <div *ngFor="let error of errors" class="error">{{error}}</div>
        </div>
      </div>

      <div *ngIf="!view && errors.length > 0" class="view-fields">
        <div *ngFor="let error of errors" class="error" style="padding: 16px;">{{error}}</div>
      </div>
    </section>

    <div class="field-editor" *ngIf="showFieldEditor">
      <div class="field-editor-header">
        <div class="title">Fields</div>
        <div class="close" (click)="toggleFieldEditor()"></div>
      </div>
      <div class="field-editor-body">
        <div cdkDropList (cdkDropListDropped)="dropEditorField($event)" class="field-editor-list">
          <div *ngFor="let item of editorFields" cdkDrag class="field-editor-item" [class.inactive]="!item.active">
            <div class="drag-handle" cdkDragHandle></div>
            <div class="field-editor-toggle" [class.active]="item.active" (click)="toggleEditorField(item)"></div>
            <div class="field-editor-name">{{item.field.name}}</div>
          </div>
        </div>
      </div>
      <div class="field-editor-actions">
        <div class="button grey" (click)="resetFieldSettings()">Reset</div>
        <div class="button green" (click)="saveFieldSettings()">Save</div>
      </div>
    </div>
  </div>
</div>
